import { Modal } from 'react-bootstrap';

type TypeConfirmationModalProps = {
  show: boolean;
  handleShow: () => void;
  handleConfirmation: () => void;
  message: string | JSX.Element;
};

export function ConfirmationModal({
  show,
  handleShow,
  handleConfirmation,
  message,
}: TypeConfirmationModalProps) {
  return (
    <Modal show={show} onHide={handleShow} centered>
      <Modal.Body>Are you sure you want to {message}?</Modal.Body>
      <Modal.Footer>
        <button
          type='button'
          className='btn btn-link text-site text-uppercase'
          onClick={handleShow}
        >
          Cancel
        </button>
        <button
          type='button'
          className='cofirm-button btn btn-primary text-uppercase'
          onClick={handleConfirmation}
        >
          confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
}
